export const CLEAR_TABLE_SETTINGS = 'CLEAR_TABLE_SETTINGS';

export const clearTableSettings = ( table ) => ({
    type: CLEAR_TABLE_SETTINGS,
    payload: {
        table,
    }
})